export declare const SENTRYIO_URL: string
export declare const ENVIRONMENT_NAME: string
export declare const VERSION: string

export const environment = {
  production: true,
  htProtocol: 'https',
  wsProtocol: 'wss',
  backendPort: '8000',
  backendPrefix: 'api-',
} as const

export const constants = {
  sentryUrl: SENTRYIO_URL,
  envName: ENVIRONMENT_NAME,
  version: VERSION,
} as const
